import script from "./ContactSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactSection.vue?vue&type=script&setup=true&lang=js"

import "./ContactSection.vue?vue&type=style&index=0&id=640012c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-640012c8"]])

export default __exports__